<template>
    <component v-bind:is="item.CtaUrl != '' ? 'a' : 'div'"
               v-bind:href="item.CtaUrl != '' ? item.CtaUrl : null"
			   v-bind:target="item.CtaUrl != '' ? (item.CtaUrl.indexOf('/') == 0 ? '_self' : '_blank') : null"
               v-bind:class="item.CtaUrl == '' ? 'no-link' : ''"
               class="card-outer col-md col-md-4">
        <div class="card card-callout">
            <div v-if="item.Image" class="card-img" v-bind:style="{ 'background-image': 'url(' + item.Image + ')' }" v-bind:aria-label="item.Title"></div>

            <div class="card-content">
                <span class="icon icon-arrow-right"></span>

                <h2>{{ item.Title }}</h2>
                <div>{{ item.CalloutCardDescription }}</div>
                <div class="cta-link">{{ item.Cta }}</div>
            </div>
        </div>
    </component>
</template>

<script>
	import DateFormatService from '../../services/date-format.service';

	export default {
		props: ['item'],
		components: {

		},
		mounted: function () {

		},
		methods: {
			formatDate(date) {
				return DateFormatService.formatDate(date);
			},
        },
    }
</script>